import store from "@/state/store";

export default [
    {
        path: "/",
        name: "default",
        meta: {
            authRequired: true,
        },
        component: () => import("./views/dashboards/default"),
    },
    {
        path: "/login",
        name: "login",
        component: () => import("./views/account/login"),
        meta: {
            beforeResolve(routeTo, routeFrom, next) {
                if (store.getters["auth/loggedIn"]) {
                    next({ name: "default" });
                } else {
                    next();
                }
            },
        },
    },
    {
        path: "/choose_branch",
        meta: { authRequired: true },
        component: () => import("./views/account/branch"),
    },
    {
        path: "/register",
        name: "Register",
        component: () => import("./views/account/register"),
        meta: {
            beforeResolve(routeTo, routeFrom, next) {
                if (store.getters["auth/loggedIn"]) {
                    next({ name: "default" });
                } else {
                    next();
                }
            },
        },
    },
    {
        path: "/forgot-password",
        name: "Forgot password",
        component: () => import("./views/account/forgot-password"),
        meta: {
            beforeResolve(routeTo, routeFrom, next) {
                if (store.getters["auth/loggedIn"]) {
                    next({ name: "default" });
                } else {
                    next();
                }
            },
        },
    },
    {
        path: "/logout",
        name: "logout",
        meta: {
            authRequired: true,
            beforeResolve(routeTo, routeFrom, next) {
                localStorage.removeItem("user");
                localStorage.removeItem("token");
                localStorage.removeItem("branches");
                localStorage.removeItem("financialyear");
                localStorage.removeItem("license");
                localStorage.removeItem("active_license");
                const authRequiredOnPreviousRoute = routeFrom.matched.some(
                    (route) => route.push("/login")
                );
                next(
                    authRequiredOnPreviousRoute
                        ? { name: "default" }
                        : { ...routeFrom }
                );
            },
        },
    },
    {
        path: "/404",
        name: "404",
        component: require("./views/utility/404").default,
    },
    {
        path: "*",
        redirect: "404",
    },
    {
        path: "/newmember",
        meta: { authRequired: true },
        component: () => import("./views/members/newmember"),
    },
    {
        path: "/viewmembers",
        meta: { authRequired: true },
        component: () => import("./views/members/viewmembers"),
    },
    {
        path: "/account_balances",
        meta: { authRequired: true },
        component: () => import("./views/members/account_balances"),
    },
    {
        path: "/memberprofile",
        meta: { authRequired: true },
        component: () => import("./views/members/profile"),
    },
    {
        path: "/printprofile",
        meta: { authRequired: true },
        component: () => import("./views/members/printprofile"),
    },
    {
        path: "/membershipfees",
        meta: { authRequired: true },
        component: () => import("./views/members/membershipfees"),
    },
    {
        path: "/subscriptionfees",
        meta: { authRequired: true },
        component: () => import("./views/members/subscriptionfees"),
    },
    {
        path: "/registrationfees",
        meta: { authRequired: true },
        component: () => import("./views/members/registrationfees"),
    },
    {
        path: "/passbookfees",
        meta: { authRequired: true },
        component: () => import("./views/members/passbookfees"),
    },
    {
        path: "/printmembershipfee",
        meta: { authRequired: true },
        component: () => import("./views/members/printmembershipfee"),
    },
    {
        path: "/printregistrationfee",
        meta: { authRequired: true },
        component: () => import("./views/members/printregistrationfee"),
    },
    {
        path: "/savings",
        meta: { authRequired: true },
        component: () => import("./views/savings/savings"),
    },
    {
        path: "/printsaving",
        meta: { authRequired: true },
        component: () => import("./views/savings/printsavings"),
    },
    {
        path: "/shares",
        meta: { authRequired: true },
        component: () => import("./views/savings/shares"),
    },
    {
        path: "/printshare",
        meta: { authRequired: true },
        component: () => import("./views/savings/printshare"),
    },
    {
        path: "/withdraws",
        meta: { authRequired: true },
        component: () => import("./views/savings/withdraws"),
    },
    {
        path: "/printwithdraw",
        meta: { authRequired: true },
        component: () => import("./views/savings/printwithdraw"),
    },
    {
        path: "/withdrawcharges",
        meta: { authRequired: true },
        component: () => import("./views/savings/withdrawcharges"),
    },
    {
        path: "/loantypes",
        meta: { authRequired: true },
        component: () => import("./views/loans/loantypes"),
    },
    {
        path: "/loancharges",
        meta: { authRequired: true },
        component: () => import("./views/loans/loancharges"),
    },
    {
        path: "/applicants",
        meta: { authRequired: true },
        component: () => import("./views/members/applicants"),
    },
    {
        path: "/applications",
        name: 'loanapplication',
        meta: { authRequired: true },
        component: () => import("./views/loans/application"),
    },
    {
        path: "/disbursements",
        meta: { authRequired: true },
        component: () => import("./views/loans/disbursements"),
    },
    {
        path: "/runningloans",
        meta: { authRequired: true },
        component: () => import("./views/loans/running"),
    },
    {
        path: "/closedloans",
        meta: { authRequired: true },
        component: () => import("./views/loans/closed"),
    },
    {
        path: "/loanarrears",
        meta: { authRequired: true },
        component: () => import("./views/loans/arrears"),
    },
    {
        path: "/recordexpense",
        meta: { authRequired: true },
        component: () => import("./views/expenses/record"),
    },
    {
        path: "/expenseitems",
        meta: { authRequired: true },
        component: () => import("./views/expenses/items"),
    },
    {
        path: "/expensecategories",
        meta: { authRequired: true },
        component: () => import("./views/expenses/categories"),
    },
    {
        path: "/viewexpenses",
        meta: { authRequired: true },
        component: () => import("./views/expenses/view"),
    },
    {
        path: "/smscenter",
        meta: { authRequired: true },
        component: () => import("./views/smscenter/messages"),
    },
    {
        path: "/smspurchase",
        meta: { authRequired: true },
        component: () => import("./views/smscenter/smspurchase"),
    },
    {
        path: "/profile",
        meta: { authRequired: true },
        component: () => import("./views/settings/profile"),
    },
    {
        path: "/paymentoptions",
        meta: { authRequired: true },
        component: () => import("./views/settings/paymentoptions"),
    },
    {
        path: "/financialyears",
        meta: { authRequired: true },
        component: () => import("./views/settings/financialyears"),
    },
    {
        path: "/savingpackages",
        meta: { authRequired: true },
        component: () => import("./views/settings/savingpackages"),
    },
    {
        path: "/settings",
        meta: { authRequired: true },
        component: () => import("./views/settings/settings"),
    },
    {
        path: "/roles",
        meta: { authRequired: true },
        component: () => import("./views/users/roles"),
    },
    {
        path: "/users",
        meta: { authRequired: true },
        component: () => import("./views/users/users"),
    },
    {
        path: "/permissions",
        meta: { authRequired: true },
        component: () => import("./views/users/permissions"),
    },
    {
        path: "/audits",
        meta: { authRequired: true },
        component: () => import("./views/users/audits"),
    },
    {
        path: "/dueloans",
        meta: { authRequired: true },
        component: () => import("./views/reports/dueloans"),
    },
    {
        path: "/expensesreport",
        meta: { authRequired: true },
        component: () => import("./views/reports/expensesreport"),
    },
    {
        path: "/inactiveaccounts",
        meta: { authRequired: true },
        component: () => import("./views/reports/inactiveaccounts"),
    },
    {
        path: "/incomeandexpenditure",
        meta: { authRequired: true },
        component: () => import("./views/reports/incomeandexpenditure"),
    },
    {
        path: "/loanchargesreport",
        meta: { authRequired: true },
        component: () => import("./views/reports/loanchargesreport"),
    },
    {
        path: "/loaninterestsreport",
        meta: { authRequired: true },
        component: () => import("./views/reports/loaninterestsreport"),
    },
    {
        path: "/loanmonthlyreport",
        meta: { authRequired: true },
        component: () => import("./views/reports/loanmonthlyreport"),
    },
    {
        path: "/loanpaymentreport",
        meta: { authRequired: true },
        component: () => import("./views/reports/loanpaymentreport"),
    },
    {
        path: "/loanperproducts",
        meta: { authRequired: true },
        component: () => import("./views/reports/loanperproducts"),
    },
    {
        path: "/loanspermember",
        meta: { authRequired: true },
        component: () => import("./views/reports/loanspermember"),
    },
    {
        path: "/loansperuser",
        meta: { authRequired: true },
        component: () => import("./views/reports/loansperuser"),
    },
    {
        path: "/membershipfeesport",
        meta: { authRequired: true },
        component: () => import("./views/reports/membershipfeesport"),
    },
    {
        path: "/monthlysavingsanalysis",
        meta: { authRequired: true },
        component: () => import("./views/reports/monthlysavingsanalysis"),
    },
    {
        path: "/monthlyshareanalysis",
        meta: { authRequired: true },
        component: () => import("./views/reports/monthlyshareanalysis"),
    },
    {
        path: "/monthlywithdrawsanalysis",
        meta: { authRequired: true },
        component: () => import("./views/reports/monthlywithdrawsanalysis"),
    },
    {
        path: "/savingspermember",
        meta: { authRequired: true },
        component: () => import("./views/reports/savingspermember"),
    },
    {
        path: "/savingsperuser",
        meta: { authRequired: true },
        component: () => import("./views/reports/savingsperuser"),
    },
    {
        path: "/sharespermember",
        meta: { authRequired: true },
        component: () => import("./views/reports/sharespermember"),
    },
    {
        path: "/sharesperuser",
        meta: { authRequired: true },
        component: () => import("./views/reports/sharesperuser"),
    },
    {
        path: "/transactionsreport",
        meta: { authRequired: true },
        component: () => import("./views/reports/transactionsreport"),
    },
    {
        path: "/withdrawchargesreport",
        meta: { authRequired: true },
        component: () => import("./views/reports/withdrawchargesreport"),
    },
    {
        path: "/withdrawspermember",
        meta: { authRequired: true },
        component: () => import("./views/reports/withdrawspermember"),
    },
    {
        path: "/withdrawsperuser",
        meta: { authRequired: true },
        component: () => import("./views/reports/withdrawsperuser"),
    },
    {
        path: "/writtenoffloans",
        meta: { authRequired: true },
        component: () => import("./views/reports/writtenoffloans"),
    },
    {
        path: "/investments",
        meta: { authRequired: true },
        component: () => import("./views/returns/investments"),
    },
    {
        path: "/investmentreturns",
        meta: { authRequired: true },
        component: () => import("./views/returns/investmentreturns"),
    },
    {
        path: "/memberinterests",
        meta: { authRequired: true },
        component: () => import("./views/returns/memberinterests"),
    },
    {
        path: "/dividendpayouts",
        meta: { authRequired: true },
        component: () => import("./views/returns/dividendpayouts"),
    },
    {
        path: "/shareholderdividends",
        meta: { authRequired: true },
        component: () => import("./views/returns/shareholderdividends"),
    },
    {
        path: "/interestpayouts",
        meta: { authRequired: true },
        component: () => import("./views/returns/interestpayouts"),
    },
    {
        path: "/subscriptions",
        meta: { authRequired: true },
        component: () => import("./views/settings/subscriptions.vue"),
    },
    {
        path: "/expired-license",
        meta: { authRequired: true },
        component: () => import("./views/settings/expiredSubscription.vue"),
    },
    {
        path: "/online-transactions",
        meta: { authRequired: true },
        component: () => import("./views/payments/onlineTransactions.vue"),
    },
    {
        path: "/request-payout",
        meta: { authRequired: true },
        component: () => import("./views/payments/requestPayout.vue"),
    },
    {
        path: "/payout-history",
        meta: { authRequired: true },
        component: () => import("./views/payments/payoutHistory.vue"),
    },
    {
        path: "/checkoff-lists",
        meta: { authRequired: true },
        component: () => import("./views/payroll_deductions/viewcheckoffs.vue"),
    },
    {
        path: "/new-checkoff-list",
        meta: { authRequired: true },
        component: () => import("./views/payroll_deductions/newcheckoff.vue"),
    },
    {
        path: "/print-checkoff",
        meta: { authRequired: true },
        component: () => import("./views/payroll_deductions/printcheckoff.vue"),
    },
    // {
    //     path: "/deduction-requests",
    //     meta: { authRequired: true },
    //     component: () => import("./views/payroll_deductions/deductionrequests.vue"),
    // },
    {
        path: "/credit-score",
        name: 'credit-form',
        meta: { authRequired: true },
        component: () => import("./views/creditscore/creditform.vue"),
    },
    {
        path: "/credit-report",
        name: 'creditreport',
        meta: { authRequired: true },
        component: () => import("./views/creditscore/creditreport.vue"),
    },
    {
        path: "/credit-reports",
        name: 'credit-reports',
        meta: { authRequired: true },
        component: () => import("./views/creditscore/creditreports.vue"),
    },
    {
        path: "/contributions",
        meta: { authRequired: true },
        component: () => import("./views/welfare/contributions.vue"),
    },
    {
        path: "/give-away",
        meta: { authRequired: true },
        component: () => import("./views/welfare/giveAway.vue"),
    },
    {
        path: "/donations",
        meta: { authRequired: true },
        component: () => import("./views/welfare/donations.vue"),
    },
    {
        path: "/pages/404",
        name: "Error-404",
        meta: { authRequired: true },
        component: () => import("./views/utility/404"),
    },
    {
        path: "/pages/500",
        name: "Error-500",
        meta: { authRequired: true },
        component: () => import("./views/utility/500"),
    },
];
